import type { TableCommandFactory } from 'components/Table/model/TableModel';
export const requestAutoSize: TableCommandFactory = (cmdContext) => () => {
  cmdContext.updateState((draft) => {
    draft.requestedAutoSize = true;
  });
};
